
import React from 'react';



const Login = () => {



    return (
        <>
            {/* <!-- Button trigger modal --> */}
            <div className="buttons mb-2">
                <button type="button" class="btn btn-outline-dark bg-white" data-bs-toggle="modal" data-bs-target="#loginModal">
                    <span class="fa fa-sign-in me-1"></span> Login
                </button>
            </div>

            {/* <!-- Modal --> */}
            <div class="modal fade" id="loginModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" >
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Login</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <button class="btn btn-primary w-100 mb-4">
                                <span class="fa fa-google me-2"></span> Sign in With Google
                            </button>
                            <button class="btn btn-primary w-100 mb-4">
                                <span class="fa fa-facebook me-2"></span> Sign in With Facebook
                            </button>
                            <form>
                                <div class="mb-3">
                                    <label htmlFor="exampleInputEmail1" class="form-label">Email address</label>
                                    <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
                                    <div id="emailHelp" class="form-text">We'll never share your email with anyone else.</div>
                                </div>
                                <div class="mb-3">
                                    <label htmlFor="exampleInputPassword1" class="form-label">Password</label>
                                    <input type="password" class="form-control" id="exampleInputPassword1" />
                                </div>
                                <div class="mb-3 form-check">
                                    <input type="checkbox" class="form-check-input" id="exampleCheck1" />
                                    <label class="form-check-label" htmlFor="exampleCheck1">Check me out</label>
                                </div>
                                <button type="submit" class="btn btn-outline-primary w-100 mt-5">Submit</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Login
